import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ContinueDialogComponent } from '../components/continue-dialog/continue-dialog.component';
import { ProductTypeId } from '../models/enums/product-type.enum';
import { OrderResultModel, OrderResponseStatus, InvalidBasketResultModel, OrderModel } from '../models/order.model';
import {
  FailedBookingDialogComponent,
  FailedOrderDialogData,
} from '../components/failed-order-dialog/failed-order-dialog';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  public openContinueDialog(element: Element): MatDialogRef<ContinueDialogComponent> {
    const dialogRef = this.dialog.open(ContinueDialogComponent, {
      disableClose: true,
    });

    this.centerDialogIntoElement(dialogRef, element);

    return dialogRef;
  }

  public openFailedOrderDialog(
    element: Element,
    result: OrderResultModel,
    orderDataFn: () => OrderModel
  ): MatDialogRef<FailedBookingDialogComponent> {
    const data: FailedOrderDialogData = { status: result.status };

    if (result.status === OrderResponseStatus.NoAvailability) {
      const orderData = orderDataFn();
      const invalidOptions = (result as InvalidBasketResultModel).invalidOptionIds.map((optionId) => {
        const invalidBasketOption = orderData.basket.options.find((option) => option.optionId == optionId);
        return { optionName: invalidBasketOption.name, productTypeId: invalidBasketOption.productTypeId };
      });

      data.hotelInvalidOptions = invalidOptions
        .filter((x) => x.productTypeId == ProductTypeId.hotel)
        .map((x) => x.optionName);
      data.tourInvalidOptions = invalidOptions
        .filter((x) => x.productTypeId == ProductTypeId.tour || x.productTypeId == ProductTypeId.winery)
        .map((x) => x.optionName);
      data.eventInvalidOptions = invalidOptions
        .filter((x) => x.productTypeId == ProductTypeId.event)
        .map((x) => x.optionName);
    }

    const dialogRef = this.dialog.open(FailedBookingDialogComponent, {
      disableClose: true,
      data,
    });

    this.centerDialogIntoElement(dialogRef, element);

    return dialogRef;
  }

  private centerDialogIntoElement<T extends { height: number }>(dialogRef: MatDialogRef<T>, element: Element) {
    const dialogHeight = dialogRef.componentInstance.height;
    const { top, height } = element.getBoundingClientRect();
    const dialogTop = top + (height - dialogHeight) / 2;

    dialogRef.updatePosition({
      top: `${dialogTop}px`,
    });
  }
}
